export const CURRENT_BOARD_ID_SET = 'CURRENT_BOARD_ID_SET';
export const VISIBLE_BOARD_ID_SET = 'VISIBLE_BOARD_ID_SET';
